import axios from 'axios';
import { Store } from '@reduxjs/toolkit';
import { setAuth } from '../Components/Redux/authSlice';

// Set the base URL for all axios requests
axios.defaults.baseURL = 'https://api.sanabileducation.com/';

export const setupAxiosInterceptors = (store: Store) => {
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            // Check if error is 401 (Unauthorized)
            if (error.response && error.response.status === 401) {
                // Dispatch logout action
                store.dispatch(setAuth(false));

                // Optional: Clear token from cookies if your backend doesn't do it
                // document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
            return Promise.reject(error);
        }
    );

    // Add request interceptor to attach token if it exists (globally)
    axios.interceptors.request.use(
        (config) => {
            const getCookie = (name: string) => {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop()?.split(';').shift();
            };

            const token = getCookie('token');
            if (token) {
                // console.log('Interceptor attaching token:', token.substring(0, 10) + '...');
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                // console.warn('Interceptor: No token found in cookies');
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
};
